<template>
  <div class="w-view-shell">
    <!-- 面包屑  -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>全部课程</el-breadcrumb-item>
      <el-breadcrumb-item class="ke">{{
        course_info.cate_name
      }}</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="video-view-shell">
      <div class="video-shell">
        <video
          :src="video_src"
          controls="controls"
          id="myVideo"
          :poster="course_info.course_img"
          controlslist="noplaybackrate nodownload noremoteplayback disablePictureInPicture"
          disablePictureInPicture="true"
          oncontextmenu="return false;" 
          ondragstart="return false;"
          @play="play()"
          @pause="pause"
          preload="preload"
          @ended="ended"
          @error="error"
          @waiting="waiting"
          @ratechange="onratechange"
        >
          对不起，您的浏览器暂不支持video视频标签!
        </video>
        <!-- <img :src="course_info.course_img" v-else alt="" /> -->
      </div>
    </div>
    <!--        视频抓拍-->
    <div
      class="video-photo-shell"
      v-show="photo_show"
      @click.stop="stopNavigator"
    >
      <div class="camera_outer" @click.stop="">
        <div class="title" v-if="photo_type == 1">人脸识别</div>
        <div class="title" v-if="photo_type == 2">视频抓拍</div>
        <div class="title" v-if="photo_type == 3">上传头像</div>
        <div class="photo-tips" v-if="photo_type == 1 || photo_type == 2">
          <span>人脸识别提示：</span>
        </div>
        <div class="photo-tips" style="text-indent: 40px;" v-if="photo_type == 1 || photo_type == 2">
          <span>根据湖南省药监局要求，</span>
          系统将通过
          <span>人脸识别及随机抓拍</span>
          监管学习过程，
          <span>严防代学、挂机刷课</span>
          。请确保摄像头对准本人，严禁使用照片等非本人方式，否则省局将
          <span>判定作弊，课程全部重学。</span>
        </div>
        <div class="photo-tips" v-if="photo_type == 3">
          温馨提示：您还未上传头像,请上传本人真实照片,用于后续进行人脸识别!
        </div>
        <div
          class="submit-photo-btn"
          @click.stop="first_up_img()"
          v-if="photo_type == 1"
        >
          点击识别
        </div>
        <div
          class="submit-photo-btn"
          @click.stop="up_user_img()"
          v-if="photo_type == 3"
        >
          点击拍照
        </div>
        <video
          id="videoCamera"
          :width="videoWidth"
          :height="videoHeight"
          autoplay
        ></video>
        <canvas
          style="display:none;"
          id="canvasCamera"
          :width="videoWidth"
          :height="videoHeight"
        ></canvas>
        <div class="photo_down_time" v-if="photo_down_time > 0">
          {{ photo_down_time }}
        </div>
      </div>
    </div>
    <div
      class="video-photo-shell"
      v-show="applet_show"
      @click.stop="applet_show = false"
    >
      <div class="camera_outer">
        <div class="title">
          电脑需安装或自带摄像头， 若没有, 您可以扫码关注公众号进行学习
        </div>
        <img src="@/assets/gzh.jpg" alt="" class="applet-img" />
      </div>
    </div>

    <el-dialog
      width="30%"
      title="学习评价"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
      <div class="evaluate">
        <span>请您对本堂课程学习进行评价</span>
        <div class="check">
          <div>
            <el-radio v-model="checked" label="1" border size="medium">非常满意</el-radio>
          </div>
          <div>
            <el-radio v-model="checked" label="2" border size="medium">基本满意</el-radio>
          </div>
        </div>
        <div class="check">
          <div>
            <el-radio v-model="checked" label="3" border size="medium">一般满意</el-radio>
          </div>
          <div>
            <el-radio v-model="checked" label="4" border size="medium">不太满意</el-radio>
          </div>
        </div>
        <div class="hint">您对本堂课程学习的建议(非必填)：</div>
        <el-input
          type="textarea"
          :autosize="{ minRows: 4, maxRows: 8}"
          style="width: 70%;font-size: 18px;"
          placeholder="非必填"
          v-model="remark">
        </el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSubmit">提交</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="30%"
      title="温馨提示"
      align="center"
      :visible.sync="advise">
      <div class="advise">
        <p>祝贺：您已完成专业课程的学习（60岁免考），等待3-5个工作日省局审核，考试请进手机学习平台“正式考核”，或者扫下图二维码进入考试。考前多看“<span>复习资料</span>”助力顺利通过考试！</p>
        <img src="../../../assets/exam.png" alt="">
      </div>
      <span slot="footer" class="advise_footer">
        <el-button type="primary" @click="advise = false">知道了</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "Coursetobuy",
  data() {
    return {
      photo_down_time: -1,
      applet_show: false,
      course_id: 0,
      course_info: {},
      video_list: [],
      play_info: {
        directory_name: "视频详情",
        file_url: "",
      },
      photo_time: [],
      directory_id: 0,
      course_type: 1,
      study_time: 0,
      start_study_time: 0,
      end_time: 0,
      start_time: 0,
      play_time: 0,
      current_play_time: 0,
      img_url: "",
      video_src: "",
      photo_timer: 3,
      // 抓拍
      videoWidth: 430,
      videoHeight: 320,
      imgSrc: "",
      thisCancas: null,
      thisContext: null,
      thisVideo: null,
      openVideo: false,
      photo_show: false,
      free_tips: true,
      timer_log: null,
      is_photo: true,
      allow_play: false,
      allow_camera: false,
      user_info: "",
      photo_type: 1, // 1 第一次拍照 2 后续拍照 3 未上传头像
      old_play_time: 0,
      handle_allow: true,
      dialogVisible: false,
      remark: '',
      checked: '1',
      p_idx: 0,
      p_to_idx: -1,
      finished: false,
      advise: false,
      player: null,
      pauseState: false,
      timeDateNum: 0,
      dateTime: 0,
      errNum: 0
    };
  },
  created() {
    this.course_id = this.$route.query.course_id;
    this.get_phar_info()
    window.unbeforeunload(() => {
      if (this.player) {
        this.player.pause()
        this.player = null
      }
      // this.up_study_log();
      window.clearInterval(this.timer_log);
      clearInterval(this.timeDate)
      this.API.post2("user/course_in-learn_in", {
        directory_id: this.directory_id,
        course_id: this.play_info.course_id,
        course_type: this.play_info.course_type,
        play_time: this.current_play_time,
        record_id: this.play_info.record_id || 0
      })
      this.API.post2("user/phar_in-directory_leave", {
        directory_id: this.directory_id,
      }).then((res) => {
        console.log(res);
      });
    })
    window.onunload(() => {
      if (this.player) {
        this.player.pause()
        this.player = null
      }
      // this.up_study_log();
      window.clearInterval(this.timer_log);
      clearInterval(this.timeDate)
      this.API.post2("user/course_in-learn_in", {
        directory_id: this.directory_id,
        course_id: this.play_info.course_id,
        course_type: this.play_info.course_type,
        play_time: this.current_play_time,
        record_id: this.play_info.record_id || 0
      })
      this.API.post2("user/phar_in-directory_leave", {
        directory_id: this.directory_id,
      }).then((res) => {
        console.log(res);
      });
    })
  },
  mounted() {
    this.handle_allow = true;
    this.getUserInfo();
    this.$nextTick(() => {
      const a_link = document.createElement("a")
      document.body.appendChild(a_link);
      a_link.click();
    })
  },
  activated () {
    if (this.player) {
      this.player.pause()
      this.player = null
    }
  },
  destroyed() {
    if (this.player) {
      this.player.pause()
      this.player = null
    }
    let video = document.getElementById("myVideo");
    video.removeEventListener('enterpictureinpicture', this.vidoe_forbid);
    // this.up_study_log();
    window.clearInterval(this.timer_log);
    clearInterval(this.timeDate)
    this.API.post2("user/course_in-learn_in", {
      directory_id: this.directory_id,
      course_id: this.play_info.course_id,
      course_type: this.play_info.course_type,
      play_time: this.current_play_time,
      record_id: this.play_info.record_id || 0
    })
    this.API.post2("user/phar_in-directory_leave", {
      directory_id: this.directory_id,
    }).then((res) => {
      console.log(res);
    });
    let el = document.body
    if (el.addEventListener) {
      window.addEventListener("offline", function () {}, true)
    } else if (el.attachEvent) {
      window.addachEvent("onoffline", function () {})
    } else {
      window.onoffline = function () {}
    }
  },
  methods: {
    change (value) {
      console.log(value)
    },
    getUserInfo() {
      this.API.post("user/user_infos-user_info", {}).then((res) => {
        this.user_info = res.data.user_info;
        this.$emit("get-info");
      });
    },
    // 头像上传
    up_user_img() {
      let _this = this;
      if (!_this.allow_camera) {
        return;
      }
      // canvas画图
      _this.thisContext.drawImage(
        _this.thisVideo,
        0,
        0,
        _this.videoWidth,
        _this.videoHeight
      );
      // 获取图片base64链接
      let image = _this.thisCancas.toDataURL("image/png");
      _this.dealImage(image, 600, function(base64) {
        image = base64;
        let fd = new FormData();
        fd.append("token", localStorage.getItem("token"));
        fd.append("file", image);
        _this.API.post("user/user_infos-upload_img", fd).then((r) => {
          _this.API.post("user/user_infos-edit_user", {
            head_img: r.data.file_path,
            sex: _this.user_info.sex ? _this.user_info.sex : 1,
            nick_name: _this.user_info.nick_name,
            company_id: _this.user_info.company_id || 0,
          }).then((res) => {
            _this.stopNavigator();
            _this.photo_type = 1;
            _this.API.SMessage("头像上传成功");
            _this.getUserInfo();
            _this.get_phar_play();
          });
        });
      });
    },
    // 随堂练习
    go_test(item, index) {
      this.$router.push({
        path:
          "/contact?course_id=" +
          this.course_id +
          "&course_type=" +
          this.course_type +
          "&directory_id=" +
          item.directory_id +
          "&=timestamp" +
          new Date().getTime(),
      });
    },
    // 人脸识别
    first_up_img() {
      if (!this.handle_allow) {
        return this.API.SMessage("操作过于频繁");
      }
      this.handle_allow = false;
      setTimeout(() => {
        this.handle_allow = true;
      }, 2000);
      let _this = this;
      if (!_this.allow_camera) {
        return;
      }
      // canvas画图
      _this.thisContext.drawImage(
        _this.thisVideo,
        0,
        0,
        _this.videoWidth,
        _this.videoHeight
      );
      // 获取图片base64链接
      let video = document.getElementById("myVideo");
      video.pause();
      let image = _this.thisCancas.toDataURL("image/png");
      _this.dealImage(image, 600, function(base64) {
        image = base64;
        let fd = new FormData();
        fd.append("token", localStorage.getItem("token"));
        fd.append("file", image);
        _this.API.post("user/user_infos-upload_img", fd).then((res2) => {
          _this.API.post("user/course_in-snapshot", {
            img_url: res2.data.file_path,
          }).then((res) => {
            if (res.errno == 0) {
              video.play();
              _this.API.SMessage("验证成功");
              _this.allow_play = true;
              _this.photo_type = 2;
              _this.stopNavigator();
            } else {
              _this.allow_play = false;
              _this
                .$confirm(res.message + ",请确定是本人后重试?", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                })
                .then(() => {
                  // _this.first_up_img()
                })
                .catch(() => {
                  _this.stopNavigator();
                });
            }
          });
        });
      });
    },
    // 图片压缩
    dealImage(base64, w, callback) {
      var newImage = new Image();
      var quality = 0.8; //压缩系数0-1之间
      newImage.src = base64;
      newImage.setAttribute("crossOrigin", "Anonymous"); //url为外域时需要
      var imgWidth, imgHeight;
      newImage.onload = function() {
        imgWidth = this.width;
        imgHeight = this.height;
        var canvas = document.createElement("canvas");
        var ctx = canvas.getContext("2d");
        if (Math.max(imgWidth, imgHeight) > w) {
          if (imgWidth > imgHeight) {
            canvas.width = w;
            canvas.height = (w * imgHeight) / imgWidth;
          } else {
            canvas.height = w;
            canvas.width = (w * imgWidth) / imgHeight;
          }
        } else {
          canvas.width = imgWidth;
          canvas.height = imgHeight;
          quality = 0.6;
        }
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(this, 0, 0, canvas.width, canvas.height);
        var base64 = canvas.toDataURL("image/jpeg", quality); //压缩语句
        callback(base64);
      };
    },
    // 禁止拖动
    video_uptime(time) {
      let _this = this;
      let video = document.getElementById("myVideo");
      let currentTime = time;
      let dif = Math.abs(this.old_play_time - currentTime);
      if (dif > 1.5 && _this.play_info.is_finish == 0) {
        video.pause()
        if (_this.play_info.is_record == 0) {
        } else if (_this.play_info.is_record == 1) {
          video.currentTime = _this.old_play_time;
          _this.API.SMessage("未学习完课程,请不要快进后退");
        } else if (_this.play_info.course_info.is_record == 0) {
          _this.current_play_time = time;
        } else {
          video.currentTime = _this.old_play_time;
          _this.API.SMessage("未学习完课程,请不要快进后退");
        }
      } else {
        _this.current_play_time = parseInt(time);
        this.old_play_time = time;
      }
    },
    onratechange () {
      let video = document.getElementById("myVideo");
      video.playbackRate = 1
    },
    play() {
      let video = document.getElementById("myVideo");
      if (this.pauseState) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        // video.pause()
        this.API.post('user/phar_in-play_record', {directory_id: this.directory_id,}).then(res => {
          loading.close();
          if (res.errno == 0) {
            this.studyRecord()
            this.play_info.record_id = res.data.play_info.record_id
            this.pauseState = false
            // video.play()
          } else {
            video.pause()
            this.$message.error(res.message || '学习记录信息获取失败!');
          }
        }).catch((err) => {
          loading.close()
          let that = this
          if (!window.navigator.onLine) {
            let video = document.getElementById("myVideo");
            video.pause()
            that.$message.error('请检查您的网络后播放!');
          }
          let el = document.body
          if (el.addEventListener) {
            window.addEventListener("offline", function () {
              let video = document.getElementById("myVideo");
              video.pause()
              that.$message.error('请检查您的网络后播放!');
            }, true)
          } else if (el.attachEvent) {
            window.addachEvent("onoffline", function () {
              let video = document.getElementById("myVideo");
              video.pause()
              that.$message.error('请检查您的网络后播放!');
            })
          } else {
            window.onoffline = function () {
              let video = document.getElementById("myVideo");
              video.pause()
              that.$message.error('请检查您的网络后播放!');
            }
          }
        })
      }
      if (
        (!this.allow_play && this.play_info.is_photo) ||
        (!this.allow_play && this.play_info.course_info.is_photo)
      ) {
        // if (!this.allow_play) {
        video.pause();
        this.getCompetence();
        if (this.photo_type == 2) {
          this.photo_down_time = 5;
          if (this.player) {
            this.player.pause();
            this.player = null
          }
          const a_link = document.createElement("a")
          document.body.appendChild(a_link);
          a_link.click();
          this.$nextTick(() => {
            this.player = new Audio("https://video.xyyysp.com/54321.mp3");
            this.player.play();
          })
          let timer = setInterval(() => {
            if (this.photo_down_time == 0) {
              if (this.player) {
                this.player.pause()
                this.player = null
              }
              clearInterval(timer);
              this.setImage();
            } else {
              this.photo_down_time--;
            }
          }, 1000);
        }
      }
      let _this = this;
      _this.free_tips = true;
    },
    pause() {
      // this.up_study_log();
      this.pauseState = true
      clearInterval(this.timer_log)
      this.API.post2("user/course_in-learn_in", {
        directory_id: this.directory_id,
        course_id: this.play_info.course_id,
        course_type: this.play_info.course_type,
        play_time: this.current_play_time,
        record_id: this.play_info.record_id || 0
      })
      this.API.post2("user/phar_in-directory_leave", {
        directory_id: this.directory_id,
      }).then((res) => {
        // this.play_info.record_id = ''
      });
    },
    ended() {
      if (this.current_play_time == this.play_info.file_time) {
        this.up_study_log();
        if (this.play_info.is_finish == 0 && this.play_info.is_comment == 0) {
          this.dialogVisible = true;
          return;
        }
        window.clearInterval(this.timer_log);
      } else {
        let video = document.getElementById("myVideo");
        video.pause()
      }
    },
    error() {
      // this.API.SMessage('视频播放出错,请手动进行刷新,再点击播放!')
      window.clearInterval(this.timer_log);
    },
    waiting() {
      // this.API.SMessage('网络不稳定,您可以点击暂停待视频缓冲后再进行播放')
    },
    // 抓拍
    round_photo_up() {
      let _this = this;
      let video = document.getElementById("myVideo");
      video.pause();
      _this.dealImage(_this.imgSrc, 600, function(base64) {
        _this.imgSrc = base64;
        let fd = new FormData();
        fd.append("token", localStorage.getItem("token"));
        fd.append("file", _this.imgSrc);
        _this.API.post("user/user_infos-upload_img", fd).then((res2) => {
          _this.API.post("user/course_in-photo_in", {
            directory_id: _this.video_list[_this.$route.query.index].directory_id,
            course_id: _this.play_info.course_id,
            img_url: res2.data.file_path,
            course_type: _this.play_info.course_type,
            study_time: Math.ceil(video.currentTime)
          }).then((res) => {
            _this.finished = false;
            if (res.errno == 0) {
              clearInterval(_this.timeDate)
              video.play();
              _this.p_idx++
              _this.allow_play = true;
              _this.stopNavigator();
              _this.API.SMessage("验证成功");
              setTimeout(() => {
                _this.is_photo = true;
              }, 3000);
            } else {
              _this.clertRemain()
              _this.allow_play = false;
              _this
                .$confirm("视频抓拍失败，重新抓拍？", "提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning",
                  center: true,
                })
                .then(() => {
                  if (_this.timeDate && _this.timeDateNum >= 29) {
                    clearInterval(this.timeDate)
                  }
                  _this.photo_down_time = 5;
                  if (_this.player) {
                    _this.player.pause();
                    _this.player = null
                  }
                  const a_link = document.createElement("a")
                  document.body.appendChild(a_link);
                  a_link.click();
                  _this.$nextTick(() => {
                    _this.player = new Audio("https://video.xyyysp.com/54321.mp3");
                    _this.player.play();
                  })
                  let timer = setInterval(() => {
                    if (_this.photo_down_time == 0) {
                      if (_this.player) {
                        _this.player.pause()
                        _this.player = null
                      }
                      clearInterval(timer);
                      _this.setImage();
                    } else {
                      _this.photo_down_time--;
                    }
                  }, 1000);
                })
                .catch(() => {
                  _this.stopNavigator();
                });
            }
          });
        });
      });
    },
    // 点击列表
    cut_play(item) {
      let video = document.getElementById("myVideo");
      if (video) {
        video.currentTime = 0;
      }
      this.old_play_time = 0;
      this.directory_id = item.directory_id;
      this.API.post2("user/user_infos-thumb_status", {}).then((res) => {
        if (res.errno == 0) {
          if (res.data.thumb_status) {
            this.photo_type = 1;
            this.allow_play = false;
            window.clearInterval(this.timer_log);
            this.video_src = "";
            this.get_phar_play();
          } else {
            this.photo_type = 3;
            this.getCompetence();
          }
        } else {
          this.API.SMessage(res.message);
        }
      });
    },
    // 药师课程列表
    get_phar_info() {
      this.API.post("user/phar_in-phar_course_info", {
        course_id: this.course_id,
      }).then((res) => {
        if (res.errno != 0) {
          return;
        }
        this.video_list = res.data.course_list;
        this.course_info = {
          course_img: this.video_list[this.$route.query.index].course_img,
          cate_name: this.video_list[this.$route.query.index].directory_name,
        };
        this.cut_play(this.video_list[this.$route.query.index])
      });
    },
    vidoe_forbid (e) {
      e.preventDefault();
      if (document.pictureInPictureElement) {
        document.exitPictureInPicture();
      }
    },
    // 药师课程播放地址
    get_phar_play() {
      let _this = this;
      this.API.post("user/phar_in-phar_play", {
        directory_id: this.directory_id,
      }).then((res) => {
        if (res.errno != 0) {
          if (res.code == 2078) {
            this.photo_type = 3;
            this.getCompetence();
          }
          return;
        }
        let video = document.getElementById("myVideo");
        video.addEventListener('enterpictureinpicture', this.vidoe_forbid);
        this.play_info = res.data.play_info;
        this.play_info.play_time = Number(this.play_info.play_time)
        if (this.play_info.play_time > this.play_info.file_time) {
          this.play_info.play_time = this.play_info.file_time
        }
        if (this.play_info.is_finish == 1 && this.play_info.is_comment == 0) {
          this.dialogVisible = true;
          return;
        }
        this.video_src = this.play_info.file_url;
        this.play_time = this.play_info.play_time;
        this.start_time = this.play_info.play_time;
        this.photo_time = res.data.play_info.photo_time
          ? res.data.play_info.photo_time
          : [];
        this.photo_time.push(this.play_info.file_time+3)
        for (let i in this.photo_time) {
          if (this.photo_time[i] > this.play_info.play_time) {
            this.p_idx = Number(i)
            break;
          } else {
            this.p_idx = Number(i)
          }
        }
        if (this.play_info.is_photo == 1) {
          // 第一次抓拍
          _this
            .$confirm(
              "播放视频前请确保您已上传真实头像,并且设备有摄像头且已打开!",
              "提示",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true,
              }
            )
            .then((r) => {
              _this.getCompetence();
            })
            .catch((r) => {});
        }
        setTimeout(() => {
          let _this = this;
          let video = document.getElementById("myVideo");
          video.currentTime = _this.play_time;
          _this.old_play_time = _this.play_info.play_time;
          _this.current_play_time = _this.play_time;
          video.addEventListener("timeupdate", async function() {
            let timeDisplay;
            timeDisplay = Math.ceil(video.currentTime);
            await _this.video_uptime(video.currentTime);
            // 抓拍
            if (_this.photo_time.length > 0) {
              if ((_this.old_play_time >= _this.photo_time[_this.p_idx] && _this.old_play_time < _this.photo_time[_this.p_idx+1] && _this.is_photo) || (_this.play_info.file_time - _this.old_play_time < 30 && _this.p_idx < _this.photo_time.length - 1)) {
                if (_this.p_idx != _this.p_to_idx) {
                  _this.p_to_idx = _this.p_idx
                  _this.remainTime()
                } else if (_this.timeDate && _this.timeDateNum >= 29) {
                  clearInterval(this.timeDate)
                }
                _this.allow_play = false;
                _this.is_photo = false;
                video.pause();
                _this.getCompetence();
                _this.photo_down_time = 5;
                if (_this.player) {
                  _this.player.pause();
                  _this.player = null
                }
                const a_link = document.createElement("a")
                document.body.appendChild(a_link);
                a_link.click();
                _this.$nextTick(() => {
                  _this.player = new Audio("https://video.xyyysp.com/54321.mp3");
                  _this.player.play();
                })
                let timer = setInterval(() => {
                  if (_this.photo_down_time == 0) {
                    if (_this.player) {
                      _this.player.pause()
                      _this.player = null
                    }
                    clearInterval(timer);
                    _this.setImage();
                  } else {
                    _this.photo_down_time--;
                  }
                }, 1000);
              } else {
              }
            }
            // 试看结束
            if (
              timeDisplay >= _this.play_info.free_time &&
              !_this.play_info.buy_status &&
              _this.free_tips
            ) {
              _this.free_tips = false;
              video.pause();
              video.currentTime = _this.play_info.free_time;
              _this.API.SMessage("免费观看时间结束,请先购买课程");
            }
          });
        }, 800);
        if (this.play_info.is_finish == 0) {
          this.studyRecord()
        }
      });
    },
    remainTime () {
      if (this.timeDate) {
        clearInterval(this.timeDate)
      }
      this.timeDate = setInterval(() => {
        this.timeDateNum++
        if (this.timeDateNum == 30) {
          clearInterval(this.timeDate)
          this.$router.back()
        }
      }, 1000*60)
    },
    clertRemain () {
      if (this.timeDate && this.timeDateNum >= 29) {
        clearInterval(this.timeDate)
        this.$router.back()
      }
    },
    studyRecord () {
      this.timer_log = setInterval(() => {
        let video = document.getElementById("myVideo");
        if (video && !video.paused) {
          this.up_study_log();
        }
      }, 1000 * 3);
    },
    // 上传学习记录
    up_study_log() {
      if (this.play_info.is_finish != 0) {
        return;
      }
      if (!this.play_info.record_id) {
        this.errNum++
        if (this.errNum == 2) {
          let video = document.getElementById("myVideo");
          video.pause()
          this.errNum = 0
          this.$message.error('网络错误!');
        }
        return;
      }
      if (this.play_info.is_record && this.play_info.is_record == 1) {
        this.API.post2("user/course_in-learn_in", {
          directory_id: this.directory_id,
          course_id: this.play_info.course_id,
          course_type: this.play_info.course_type,
          play_time: this.current_play_time,
          record_id: this.play_info.record_id || 0
        }).then((res) => {
          if (res.errno != 0) {
            let video = document.getElementById("myVideo");
            video.pause()
            this.$message.error(res.message || '学习记录上传失败!');
          }
        }).catch((err) => {
          let that = this
          if (!window.navigator.onLine) {
            let video = document.getElementById("myVideo");
            video.pause()
            that.$message.error('请检查您的网络后播放!');
          }
          let el = document.body
          if (el.addEventListener) {
            window.addEventListener("offline", function () {
              let video = document.getElementById("myVideo");
              video.pause()
              that.$message.error('请检查您的网络后播放!');
            }, true)
          } else if (el.attachEvent) {
            window.addachEvent("onoffline", function () {
              let video = document.getElementById("myVideo");
              video.pause()
              that.$message.error('请检查您的网络后播放!');
            })
          } else {
            window.onoffline = function () {
              let video = document.getElementById("myVideo");
              video.pause()
              that.$message.error('请检查您的网络后播放!');
            }
          }
        })
      }
    },
    // 调用权限（打开摄像头功能）https
    getCompetence() {
      // window.clearInterval(this.timer_log);
      this.photo_show = true;
      this.allow_play = false;
      let _this = this;
      _this.thisCancas = document.getElementById("canvasCamera");
      _this.thisContext = this.thisCancas.getContext("2d");
      _this.thisVideo = document.getElementById("videoCamera");
      _this.thisVideo.style.display = "block";
      // 获取媒体属性，旧版本浏览器可能不支持mediaDevices，我们首先设置一个空对象
      if (navigator.mediaDevices === undefined) {
        navigator.mediaDevices = {};
      }
      // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
      // 使用getUserMedia，因为它会覆盖现有的属性。
      // 这里，如果缺少getUserMedia属性，就添加它。
      if (navigator.mediaDevices.getUserMedia === undefined) {
        navigator.mediaDevices.getUserMedia = function(constraints) {
          // 首先获取现存的getUserMedia(如果存在)
          var getUserMedia =
            navigator.webkitGetUserMedia ||
            navigator.mozGetUserMedia ||
            navigator.getUserMedia;
          // 有些浏览器不支持，会返回错误信息
          // 保持接口一致
          if (!getUserMedia) {
            //不存在则报错
            return Promise.reject(
              new Error("getUserMedia is not implemented in this browser")
            );
          }
          // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
          return new Promise(function(resolve, reject) {
            getUserMedia.call(navigator, constraints, resolve, reject);
          });
        };
      }
      var constraints = {
        audio: false,
        video: {
          width: this.videoWidth,
          height: this.videoHeight,
          transform: "scaleX(-1)",
        },
      };
      navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function(stream) {
          // 摄像头可以正常使用
          _this.allow_camera = true;
          // 旧的浏览器可能没有srcObject
          if ("srcObject" in _this.thisVideo) {
            _this.thisVideo.srcObject = stream;
          } else {
            // 避免在新的浏览器中使用它，因为它正在被弃用。
            _this.thisVideo.src = window.URL.createObjectURL(stream);
          }
          _this.thisVideo.onloadedmetadata = function(e) {
            _this.thisVideo.play();
          };
        })
        .catch((err) => {
          _this.allow_camera = false;
          _this.photo_show = false;
          _this.applet_show = true;
          // _this.$alert('摄像头开启失败,请确定您已在设置打开摄像头,并且已允许本网站使用您的摄像头!', '提示', {
          //   confirmButtonText: '确定',
          //   callback: action => {
          //   }
          // })
        });
    },
    //  绘制图片（拍照功能）
    setImage() {
      if (this.allow_camera) {
        if (!this.finished) {
          this.finished = true;
          let _this = this;
          // canvas画图
          _this.thisContext.drawImage(
            _this.thisVideo,
            0,
            0,
            _this.videoWidth,
            _this.videoHeight
          );
          // 获取图片base64链接
          let image = this.thisCancas.toDataURL("image/png");
          _this.imgSrc = image; //赋值并预览图片
          _this.round_photo_up();
        }
      }
    },
    // 关闭摄像头
    stopNavigator() {
      if (this.player) {
        this.player.pause()
        this.player = null
      }
      this.thisVideo.srcObject.getTracks()[0].stop();
      setTimeout(() => {
        this.photo_show = false;
      }, 10);
    },

    // 提交学习评价
    handleSubmit () {
      this.dialogVisible = false
      // https://xyapi.xyyysp.com/api.php?c=user/phar_in-push_comment&token=a37DXCp1jS&score=1&content_text=1&log_id=1&directory_id=1
      this.API.post2("user/phar_in-push_comment", {
        score: this.checked,
        content_text: this.remark,
        log_id: this.play_info.log_id,
        directory_id: this.directory_id,
        record_id: this.play_info.record_id,
      }).then((res) => {
        if (this.play_info.is_finish == 0 && this.play_info.is_comment == 0) {
          this.getRate()
        } else {
          this.get_phar_play();
          this.getRate()
        }
      });
    },
    getRate () {
      this.API.post2("user/phar_in-course_end", {
        course_id: this.course_id,
      }).then((res) => {
        if (res.errno == 1) {
          this.advise = true
        } else {
          this.$router.back()
        }
      });
    }
  },
};
</script>

<style lang="less" scoped>
.video-view-shell {
  margin-bottom: 40px;

  .video-shell {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 1200px;
    background-color: #f8f8f8;
    margin-bottom: 30px;

    video {
      width: 100%;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }

  .video-info {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 32px;
    width: 1200px;
    height: 162px;
    background-color: #fff;
    border-bottom: 1px solid #e5e5e5;

    .video-info-left {
      .video-name {
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #333333;
        line-height: 42px;
      }

      .video-time {
        font-size: 28px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        margin-top: 30px;
      }
    }

    .test-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 150px;
      height: 60px;
      border: 1px solid #2aa9b5;
      border-radius: 8px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #2aa9b5;
    }
  }

  .video-list {
    background-color: #fff;
    padding: 10px 0 10px;

    .video-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 0 auto;
      width: 90%;
      background: #f4f4f4;
      border-radius: 5px;
      padding: 15px 0;

      .video-box-left {
        .item {
          display: flex;
          align-items: center;
          font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #333333;
        }
        .rate {
          display: flex;
          align-items: center;
          margin-top: 10px;
          > span {
            margin-right: 20px;
            font-weight: normal;
          }
        }
      }

      .video-type {
        margin: 0 23px 0 25px;

        img {
          width: 29px;
          height: 28px;
        }
      }

      .video-box-right {
        display: flex;
      }

      .video-status {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2aa9b5;
        margin-right: 37px;

        img {
          width: 21px;
          height: 21px;
          margin-right: 16px;
        }
      }

      .study-status {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #2aa9b5;
        margin-right: 37px;
      }
    }

    .video-box2 {
      .video-box-left {
        font-weight: 600;
      }
    }
  }
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 400;
  color: #000;
  cursor: text;
}

.el-breadcrumb {
  height: 47px;
  line-height: 47px;
}

.free {
  margin-bottom: 20px;
}

.description {
  margin-bottom: 30px;

  .van-cell {
    height: 162px;

    .title {
      min-width: 276px;
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      color: #343434;
      line-height: 42px;
    }

    .period {
      font-size: 28px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #9a9a9a;
      line-height: 60px;
    }

    .Btn {
      height: 60px;
      border: 1px solid #2aaab6;
      border-radius: 8px;
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #2baab5;
    }
  }

  .box {
    width: 1180px;
    min-height: 70px;
    background: #f4f4f4;
    border-radius: 5px;
    line-height: 70px;
    margin-left: 20px;
    margin-bottom: 10px;

    img {
      position: relative;
      top: 5px;
      width: 29px;
      height: 28px;
      margin-left: 24px;
    }

    .span1 {
      font-size: 20px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #343434;
      margin-left: 15px;
    }

    .span2 {
      float: right;
      margin-right: 38px;
      width: 74px;
      height: 17px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #2baab5;
    }
  }
}

.video-photo-shell {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0px;
  width: 100%;
  height: 100%;
  z-index: 99;

  .applet-img {
    width: 300px;
    height: 300px;
    margin: 20px auto;
  }

  .camera_outer {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 610px;
    padding: 20px 0;
    background-color: #fff;
    border: 1px solid #ccc;
    position: relative;

    .photo_down_time {
      position: absolute;
      top: 66%;
      left: 50%;
      transform: translate(-50%, -50%);
      color: red;
      font-weight: 600;
      font-size: 80px;
    }

    .title {
      width: 100%;
      font-weight: 600;
      height: 60px;
      border-bottom: 1px solid #eee;
      font-size: 20px;
      padding: 0 30px;
    }

    .photo-tips {
      width: 100%;
      padding: 0 30px;
      color: red;
      font-size: 20px;
      line-height: 30px;
      span {
        font-size: 20px;
        font-weight: bold;
      }
    }

    .submit-photo-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      height: 50px;
      width: 40%;
      color: #fff;
      background-color: rgb(0, 98, 204);
      margin: 20px auto;
      cursor: pointer;
    }
  }

  .img_bg_camera {
    width: 100%;
  }

  .tx_img {
    width: 300px;
    height: 300px;
    margin: 0 auto;
  }
}

.evaluate {
  display: flex;
  flex-direction: column;
  align-items: center;
  > span {
    text-align: center;
    font-size: 1.2em;
  }
  .check {
    display: flex;
    justify-content: space-between;
    width: 50%;
    margin-top: 30px;
  }
  .hint {
    margin: 20px 0 5px;
    width: 70%;
  }
}

.advise {
  p {
    text-indent: 45px;
    width: 100%;
    text-align: left;
    font-size: 24px;
    line-height: 40px;
    span {
      font-size: 24px;
      font-weight: bold;
      color: red;
    }
  }
  img {
    margin: 20px auto 0;
    width: 300px;
    display: block;
  }
}
/deep/ .el-dialog__title {
  font-size: 26px;
  font-weight: bold;
  color: red;
}
.advise_footer {
  display: flex;
  justify-content: center;
}
</style>
